export enum FormModsEnum {
  CREATE = 'create',
  EDIT = 'edit',
  READ_ONLY = 'read-only',
  INVALID_ID = 'invalid-id',
}
